module.exports = __webpack_public_path__ + "img/hotel.9459e5ba.png";